import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { ScreenRegistrationDataResponse } from '@/main/models/response/screenResponse';
import { ScreenRegistrationRequest } from '@/main/models/request/screenRequest';

export abstract class IScreenApi {
  abstract getByGroupWithPermissions(
    request: ScreenRegistrationRequest
  ): Promise<AxiosResponse<Result<ScreenRegistrationDataResponse[]>>>;
}

